import { OperatorConfigForm } from '@/components/settings/operator-config-form';
import { ScannerConfigForm } from '@/components/settings/scanner-config-form';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Card } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { trpc } from '@/lib/trpc';
import { useAuthStore } from '@/store/auth-store';

// Settings — two tabs:
//   1. Personal (operatorProcedure: every operator can edit their own row).
//   2. Scanner  (config.update is admin-only; non-admins see read-only view).
//
// The architecture spec (§ 21.4.5) describes a 5-tab wizard (Bankroll /
// Filters / Risk / Notifications / Backtest preview). V1 collapses Bankroll +
// Risk into Personal because they share the same DB row, and parks the
// Notifications + Backtest tabs as V2 — those need Telegram + replay engine
// endpoints that don't exist yet.

export function SettingsPage() {
  const role = useAuthStore((s) => s.role);
  const isAdmin = role === 'admin';
  const me = trpc.me.get.useQuery();
  const cfg = trpc.config.get.useQuery();

  return (
    <div className="space-y-4">
      <header>
        <h1 className="font-brand text-3xl tracking-[0.25em] text-foreground">MI CONFIG</h1>
        <p className="text-xs text-muted-foreground">
          Tus preferencias personales (kelly, edge mínimo, etc.) y la config del sistema (sólo
          admins pueden modificar).
        </p>
      </header>

      <Tabs defaultValue="personal" className="space-y-4">
        <TabsList>
          <TabsTrigger value="personal">Mis preferencias</TabsTrigger>
          <TabsTrigger value="scanner">Sistema</TabsTrigger>
          <TabsTrigger value="notifications">Notificaciones (V2)</TabsTrigger>
        </TabsList>

        <TabsContent value="personal">
          {me.isLoading && <Skeleton className="h-64" />}
          {me.error && (
            <Alert variant="destructive">
              <AlertTitle>No se pudo cargar tu perfil</AlertTitle>
              <AlertDescription>{me.error.message}</AlertDescription>
            </Alert>
          )}
          {me.data?.config && (
            <Card className="p-4">
              <OperatorConfigForm profile={me.data.operator} config={me.data.config} />
            </Card>
          )}
        </TabsContent>

        <TabsContent value="scanner">
          {cfg.isLoading && <Skeleton className="h-64" />}
          {cfg.error && (
            <Alert variant="destructive">
              <AlertTitle>No se pudo cargar la config del scanner</AlertTitle>
              <AlertDescription>{cfg.error.message}</AlertDescription>
            </Alert>
          )}
          {cfg.data && (
            <Card className="p-4">
              <ScannerConfigForm current={cfg.data} isAdmin={isAdmin} />
            </Card>
          )}
        </TabsContent>

        <TabsContent value="notifications">
          <Alert>
            <AlertTitle>V2 — pending wiring</AlertTitle>
            <AlertDescription>
              Telegram bot integration + email digest están en el roadmap pero el endpoint de
              notification preferences no existe aún.
            </AlertDescription>
          </Alert>
        </TabsContent>
      </Tabs>
    </div>
  );
}
